import { Container, CssBaseline, Grid, Icon, useTheme } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { isEmail } from "../../../functions";
import { FieldText } from "../../../globalComponents/forms";
import {
  StandardButton as SB,
  StandardText as ST,
} from "../../../globalComponents/standard";
import useAlerts from "../../../globalComponents/useAlerts";
import useLogin from "./useLogin";

const LoginAdmin = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [login, setLogin] = useState({
    username: "",
    password: "",
    showPassword: false,
    validate: function () {
      return isEmail(this.username) && this.password.length > 4;
    },
  });

  const { showAlert, showLoading, dismissLoading } = useAlerts();

  const { username, password } = login;

  const { authenticate } = useLogin();

  const handleChangeValue = (e) => {
    const { name, value } = e.target;

    setLogin((l) => ({ ...l, [name]: value }));
  };

  const onLoggin = async () => {
    showLoading();
    try {
      const user = await authenticate({
        username,
        password,
      });
      if (!user) throw new Error("Acesso negado!");
      dismissLoading();
      setTimeout(function () {
        navigate("/admin", { replace: true });
      }, 1000);
    } catch (e) {
      showAlert({ title: "Acesso", description: e.message });
    }
  };

  const ret = (
    <React.Fragment>
      <CssBaseline />
      <BarComponent
        top={0}
        backgroundColor={theme.palette.primary.main}
        height={100}
      />
      <Container
        style={{
          display: "flex",
          height: "100dvh",
          width: "100%",
        }}
        maxWidth="xs"
      >
        <div
          style={{
            height: "100%",
            alignContent: "center",
            padding: 20,
          }}
        >
          <Grid
            alignItems="center"
            spacing={4}
            justifyContent="center"
            container
          >
            <Grid>
              <img
                style={{
                  //background: theme.palette.primary.main,
                  borderRadius: 10,

                  // background: "#ff6a00",
                }}
                src={"/personagem_semfundo2.png"}
                alt="Logo"
                width={150}
              />
            </Grid>
            <Grid>
              <form
                noValidate
                autoComplete="off"
                onSubmit={(e) => e.preventDefault()}
              >
                <Grid container spacing={2}>
                  <FieldText
                    xs={12}
                    onChange={handleChangeValue}
                    name="username"
                    label="Usuário"
                  />
                  <FieldText
                    xs={12}
                    passwordIcon={<Icon>visibility</Icon>}
                    onChange={handleChangeValue}
                    name="password"
                    label="Senha"
                  />

                  <Grid size={{ xs: 12 }}>
                    <SB
                      style={{ background: theme.palette.primary.main }}
                      disabled={!login.validate()}
                      fullWidth
                      onClick={onLoggin}
                      type={"submit"}
                    >
                      <ST bold={1} color={"#fff"}>
                        Acessar
                      </ST>
                    </SB>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </div>
      </Container>
      <BarComponent
        bottom={0}
        backgroundColor={theme.palette.secondary.main}
        height={100}
      />
    </React.Fragment>
  );

  return ret;
};

const BarComponent = React.memo(({ backgroundColor, height, ...other }) => (
  <div
    style={{
      position: "fixed",
      left: 0,
      right: 0,
      height: height || 100,
      display: "flex",
      zIndex: 10000,
      backgroundColor: backgroundColor || "red",
      ...other,
    }}
  ></div>
));

export default LoginAdmin;

// import javax.swing.JOptionPane;

// public class Main {
//     public static void main(String[] args) {
//         // Show a simple message dialog
//         JOptionPane.showMessageDialog(null, "AIII Thiaga!!");
//     }
// }
